import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faEnvelope,
  faUnlockAlt,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  FormCheck,
  Container,
  InputGroup,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";

import { Routes } from "../../routes";
import Policy from "./Policy";
import { SignUpModal, SignUpSuccess } from "../../components/Modal";

export default () => {
  const [input, setInput] = useState({
    id: "",
    email: "",
    pwd: "",
    pwd2: "",
    companyNm: "",
    registration: "",
    companyNmRussian: "",
    address: "",
    principal: "",
    phone: "",
    website: "",
    registrationDate: "",
    businessNm: "",
    industyCode: "",
    workerNum: "",
    revenueNum: "",
    country: "",
  });
  const [checked, setChecked] = useState(false);
  const [msg, setMsg] = useState({
    idMsg: "",
    emailMsg: "",
    pwdMsg: "",
    pwd2Msg: "",
    checkMsg: "",
    companyNmMsg: "",
    registrationMsg: "",
    addressMsg: "",
    principalMsg: "",
    phoneMsg: "",
    websiteMsg: "",
    registrationDateMsg: "",
    businessNmMsg: "",
    industyCodeMsg : "",
    workerNumMsg: "",
    revenueNumMsg: "",
    countryMsg: "",
  });

  const [control, setControl] = useState({
    disabled: false,
    body: ""
  });

  const [registered, setRegistered] = useState(false);
  const [show, setShow] = useState(false);
  const [load, setLoad] = useState(false);

  const { disabled,body } = control;

  const {
    id,
    email,
    pwd,
    pwd2,
    companyNm,
    registration,
    companyNmRussian,
    address,
    principal,
    phone,
    website,
    registrationDate,
    businessNm,
    industyCode,
    workerNum,
    revenueNum,
    country,
  } = input;
  const {
    idMsg,
    emailMsg,
    pwdMsg,
    pwd2Msg,
    checkMsg,
    companyNmMsg,
    registrationMsg,
    addressMsg,
    principalMsg,
    phoneMsg,
    websiteMsg,
    registrationDateMsg,
    businessNmMsg,
    industyCodeMsg,
    workerNumMsg,
    revenueNumMsg,
    countryMsg,
  } = msg;

  const onClick = () => {
    setShow((prev) => !prev);
  };

  const onChange = (e) => {
    const { name, value } = e.target;

    if (name === "country" && value === "korea") {
      setInput((prev) => ({ ...prev, country: 1 }));
    } else if (name === "country" && value === "russia") {
      setInput((prev) => ({ ...prev, country: 2 }));
    } else {
      setInput((prev) => ({ ...prev, [name]: value }));
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (!checked) {
      setMsg((prev) => ({
        ...prev,
        checkMsg: "이용약관과 개인정보 수집 및 이용에 동의해주세요.",
      }));
      return;
    }

    if (pwd !== pwd2) {
      setMsg((prev) => ({
        ...prev,
        checkMsg: "비밀번호가 일치하지 않습니다.",
      }));
      return;
    }

    setLoad(true);
    setControl({ 
      disabled: true,
      body : "기다리는 중! 이 작업은 시간이 오래걸립니다."
     });

     
    console.log("registration",registration);

    fetch("api/user/register", {
      method: "post",
      body: JSON.stringify({
        id,
        email,
        pwd,
        pwd2,
        registration,
        companyNm,
      }),
    })
      .then((resp) => {
        if (resp.status === 200) {
          fetch("api/company/register", {
            method: "post",
            body: JSON.stringify({
              companyNm,
              registration,
              companyNmRussian,
              address,
              principal,
              phone,
              email,
              website,
              registrationDate,
              businessNm,
              industyCode,
              workerNum,
              revenueNum,
              country,
            }),
          }).then((resp) => {
            if (resp.status === 200) {
              setLoad(false);
              setRegistered(true);
              setControl({ disabled: false,body : "회원 가입에 성공하였습니다." });
            }
          });
        } else if (resp.status === 400) {
          setControl({ disabled: false,body : "등록 이메일을 보낼 수 없습니다." });
        } else if (resp.status === 404) {
          setControl({ disabled: false,body : "회사가 이미 등록되어 있습니다." });
        }
        return resp.json();
      })
      .then((resp) => {
        console.log(resp);
        
      });
  };

  return (
    <>
      <main>
        <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
          <Container>
            <p className="text-center">
              <Card.Link
                as={Link}
                to={Routes.Home.path}
                className="text-gray-700"
              >
                <FontAwesomeIcon icon={faAngleLeft} className="me-2" />{" "}
                <FormattedMessage id="goHome" />
              </Card.Link>
            </p>
            <Row className="justify-content-center form-bg-image">
              <Col
                xs={12}
                className="d-flex align-items-center justify-content-center"
              >
                <div className="mb-4 mb-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                  <div className="text-center text-md-center mb-4 mt-md-0">
                    <h3 className="mb-0">
                      <FormattedMessage id="signup" />
                    </h3>
                  </div>
                  <Form className="mt-4">
                    <Form.Group id="id" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="id" />
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUser} />
                        </InputGroup.Text>
                        <Form.Control
                          autoFocus
                          required
                          type="text"
                          placeholder="example"
                          name="id"
                          value={id}
                          onChange={onChange}
                        />
                      </InputGroup>
                      {idMsg && <p className="text-danger">{idMsg}</p>}
                    </Form.Group>
                    <Form.Group id="email" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="email" />
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faEnvelope} />
                        </InputGroup.Text>
                        <Form.Control
                          autoFocus
                          required
                          type="email"
                          placeholder="example@company.com"
                          name="email"
                          value={email}
                          onChange={onChange}
                        />
                      </InputGroup>
                      {emailMsg && <p className="text-danger">{emailMsg}</p>}
                    </Form.Group>
                    <Form.Group id="password" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="password" />
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUnlockAlt} />
                        </InputGroup.Text>
                        <Form.Control
                          required
                          type="password"
                          placeholder="Password"
                          name="pwd"
                          value={pwd}
                          onChange={onChange}
                        />
                      </InputGroup>
                      {pwdMsg && <p>{pwdMsg}</p>}
                    </Form.Group>
                    <Form.Group id="confirmPassword" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="passwordConfirm" />
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUnlockAlt} />
                        </InputGroup.Text>
                        <Form.Control
                          required
                          type="password"
                          placeholder="Confirm Password"
                          name="pwd2"
                          value={pwd2}
                          onChange={onChange}
                        />
                      </InputGroup>
                      {pwd2Msg && <p className="text-danger">{pwd2Msg}</p>}
                    </Form.Group>
                    <FormCheck type="checkbox" className="d-flex mb-4">
                      <FormCheck.Input
                        required
                        id="terms"
                        className="me-2"
                        checked={checked}
                        onClick={() => {
                          setChecked((prev) => !prev);
                        }}
                      />
                      <FormCheck.Label htmlFor="terms">
                        <Card.Link onClick={onClick}>
                          <span className="text-decoration-underline">
                            <FormattedMessage id="usePolicy" />
                          </span>
                        </Card.Link>
                      </FormCheck.Label>
                      <Policy show={show} onClick={onClick} />
                    </FormCheck>
                    {checkMsg && <p className="text-danger">{checkMsg}</p>}

                    <Form.Group id="companyName" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="companyNm" />
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Example"
                          name="companyNm"
                          value={companyNm}
                          onChange={onChange}
                        />
                      </InputGroup>
                      {companyNmMsg && (
                        <p className="text-danger">{companyNmMsg}</p>
                      )}
                    </Form.Group>

                    <Form.Group id="companyNameInRussian" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="companyNmRussian" />
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Example"
                          name="companyNmRussian"
                          value={companyNmRussian}
                          onChange={onChange}
                        />
                      </InputGroup>
                    </Form.Group>

                    <Form.Group id="country" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="country" />
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Radio
                          name="country"
                          value="korea"
                          onChange={onChange}
                        />
                        <InputGroup.Text>
                          <FormattedMessage id="Korea" />
                        </InputGroup.Text>
                        <InputGroup.Radio
                          name="country"
                          value="russia"
                          onChange={onChange}
                        />
                        <InputGroup.Text>
                          <FormattedMessage id="Russia" />
                        </InputGroup.Text>
                      </InputGroup>
                    </Form.Group>
                    {countryMsg && (
                      <p className="text-danger">{registrationMsg}</p>
                    )}

                    <Form.Group id="RegistrationID" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="registration" />
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          required
                          type="number"
                          placeholder="00000000"
                          name="registration"
                          value={registration}
                          onChange={onChange}
                        />
                      </InputGroup>
                      {registrationMsg && (
                        <p className="text-danger">{registrationMsg}</p>
                      )}
                    </Form.Group>

                    <Form.Group id="LegalAddress" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="address" />
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Example"
                          name="address"
                          value={address}
                          onChange={onChange}
                        />
                      </InputGroup>
                      {addressMsg && (
                        <p className="text-danger">{addressMsg}</p>
                      )}
                    </Form.Group>

                    <Form.Group id="PrincipalName" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="principal" />
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Example"
                          name="principal"
                          value={principal}
                          onChange={onChange}
                        />
                      </InputGroup>
                      {principalMsg && (
                        <p className="text-danger">{principalMsg}</p>
                      )}
                    </Form.Group>

                    <Form.Group id="PhoneNumber" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="phone" />
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          required
                          type="phone"
                          placeholder="+7 (000) 0000000"
                          name="phone"
                          value={phone}
                          onChange={onChange}
                        />
                      </InputGroup>
                      {phoneMsg && <p className="text-danger">{phoneMsg}</p>}
                    </Form.Group>

                    <Form.Group id="Website" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="website" />
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          required
                          type="text"
                          placeholder="www.example.com"
                          name="website"
                          value={website}
                          onChange={onChange}
                        />
                      </InputGroup>
                      {websiteMsg && (
                        <p className="text-danger">{websiteMsg}</p>
                      )}
                    </Form.Group>

                    <Form.Group id="RegistrationDate" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="registrationDate" />
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          required
                          type="text"
                          placeholder="1991-12-31"
                          name="registrationDate"
                          value={registrationDate}
                          onChange={onChange}
                        />
                      </InputGroup>
                      {registrationDateMsg && (
                        <p className="text-danger">{registrationDateMsg}</p>
                      )}
                    </Form.Group>

                    <Form.Group id="BusinessName" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="business" />
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Example"
                          name="businessNm"
                          value={businessNm}
                          onChange={onChange}
                        />
                      </InputGroup>
                      {businessNmMsg && (
                        <p className="text-danger">{businessNmMsg}</p>
                      )}
                    </Form.Group>
                    <Form.Group id="IndustyCode" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="industyCode" />
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          required
                          type="text"
                          placeholder="00000000"
                          name="industyCode"
                          value={industyCode}
                          onChange={onChange}
                        />
                      </InputGroup>
                      {industyCodeMsg && (
                        <p className="text-danger">{industyCodeMsg}</p>
                      )}
                    </Form.Group>

                    <Form.Group id="workerNumber" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="worker" />
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          required
                          type="number"
                          placeholder="0"
                          name="workerNum"
                          value={workerNum}
                          onChange={onChange}
                        />
                      </InputGroup>
                      {workerNumMsg && (
                        <p className="text-danger">{workerNumMsg}</p>
                      )}
                    </Form.Group>

                    <Form.Group id="revenueNumber" className="mb-4">
                      <Form.Label>
                        <FormattedMessage id="revenue" /> (RUB)
                      </Form.Label>
                      <InputGroup>
                        <Form.Control
                          required
                          type="number"
                          placeholder="1000"
                          name="revenueNum"
                          value={revenueNum}
                          onChange={onChange}
                        />
                      </InputGroup>
                      {revenueNumMsg && (
                        <p className="text-danger">{revenueNumMsg}</p>
                      )}
                    </Form.Group>

                    <Button
                      variant="primary"
                      type="submit"
                      className="w-100"
                      onClick={onSubmit}
                    >
                      <FormattedMessage id="trySignup" />
                    </Button>
                  </Form>

                  <div className="d-flex justify-content-center align-items-center mt-4">
                    <span className="fw-normal">
                      <FormattedMessage id="alreadyUser" />
                      <Card.Link
                        as={Link}
                        to={Routes.Signin.path}
                        className="fw-bold"
                      >
                        {<FormattedMessage id="login" />}
                      </Card.Link>
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
      {load && <SignUpModal disabled={disabled} body={body} />}
      {registered && <SignUpSuccess email={email} />}
    </>
  );
};
